import { Skeleton } from '~/@/components/ui/skeleton'

/**
 * Renders an option in the search autocomplete as a loading skeleton
 */
export function LookupRowOptionSkeleton({ count = 5 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="flex w-full items-center gap-2 p-1.5">
          <Skeleton className="size-4 rounded-sm" />
          <Skeleton className="h-4 w-3/5" />
        </div>
      ))}
    </>
  )
}
